export const API_URL_PREFIX = process.env.REACT_APP_API_URL_PREFIX;
export const API_EDITS_ALLOWED= process.env.REACT_APP_API_EDITS_ALLOWED;

export const axiosErrorHandler = error => {
    // console.log("--- JSON error:" + JSON.stringify(error.toJSON()));
    if (error.code === 'ERR_NETWORK') {
        console.error('Network error:', error.message);
        window.confirm("Network error, please check your network connection and try again");
    } else if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error('Non-2xx response from server:', error.response.data, ', status:', error.response.status);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.error('No response received from server, request error:', error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error in setting up request:', error.message);
    }
    // console.log(error.config);
}

export const axiosConfig = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.jwt_token) {
        return {
            headers: {
                Authorization: "Bearer " + user.jwt_token
            },
            // validateStatus: function (status) {
            //     return status < 500; // Resolve only if the status code is less than 500
            // }
        };
    } else {
        return {};
    }
}

export const axiosAuthHeader = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.jwt_token) {
        return {
            headers: {
                Authorization: "Bearer " + user.jwt_token
            },
        };
    } else {
        return {};
    }
}
